const THEME_DICTIONARY = {
  topic: '99',
  mediathek: '94',
  nutshell: '97',
  shop: '98',
  learn: '96',
  events: '95',
  bpb: 'default',
};

export const computedExtensionDefaults = {
  computed: {
    $meta() {
      return this.data?.meta;
    },
    $teaser() {
      return this.data?.teaser;
    },
    $extension() {
      return this.data?.extension;
    },
    $isExternal() {
      return this.$teaser?.link?.target === 'external';
    },
    $themeClass() {
      if (!this.$meta?.theme) return false;

      return `t-${THEME_DICTIONARY[this.$meta?.theme]}`;
    },
  },
};
